module.exports = __webpack_public_path__ + "img/2-l@2x.3ed38b5c.jpg";